import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MainService } from 'src/app/services/main-service.service';
import { ProposalService } from 'src/app/services/proposal/proposal.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PendingOverdueComponent } from '../../pending-overdue/pending-overdue.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CreditReportConfirmationComponent } from '../../credit-report-confirmation/credit-report-confirmation.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-new-plans',
  templateUrl: './new-plans.component.html',
  styleUrls: ['./new-plans.component.scss'],
})
export class NewPlansComponent implements OnInit {

  bsModalRef: BsModalRef;
  @ViewChild('callbPendingOverdueComponentackModal') PendingOverdueComponent: TemplateRef<any>;
  showOverdueContractBanner = false;
  payToken: any;
  showOverdueModal = false;
  refresh_counter = 0;
  config = {
    pagination: { el: '.swiper-pagination', clickable: true, type: 'bullets' },
    spaceBetween: 15,
    width: window.innerWidth - 60
  };
  enrollmentFee: number;
  contract_service_record: any = null;
  date: Date = new Date();
  onlyCloseButton = false;
  showConfirmationDialog: boolean = false;
  continueButton: boolean = false;
  planExpanded: boolean = false;
  validValue: boolean = false;
  ar: any;
  stepHeader: any;
  creditReportOption = true;
  private originalRecurringAmounts: number[] = [];
  private originalToPayTodayAmounts: number[] = [];
  constructor(
    public mainService: MainService,
    public proposal: ProposalService,
    public router: Router,
    public route: ActivatedRoute,
    private modalService: BsModalService,
    public Proposal: ProposalService,
    private dialog:MatDialog
  ) { 
    let xToken =  this.route.snapshot.queryParams['x-token']
    if(!xToken){
      let emailToken=JSON.parse(localStorage.getItem('x-token'))
      this.router.navigate([], {
        relativeTo:this.route,
        queryParams: { 'x-token':emailToken },
        queryParamsHandling: 'merge',
      });
    }
  }

  contractToken: any = '';
  plans: any = {};
  planInfo: any = {};
  selected_plan_index: any;
  show_all_plans = false;

  ngOnInit() {
    this.mainService.topHeader.subscribe((data) => {
      this.stepHeader = data;
      console.log(this.stepHeader);
    });
    this.route.params.subscribe((data: any) => {
      this.contractToken = data.token;
    });
    this.route.queryParams.subscribe((data: any) => {
      this.ar = data.ar ? data.ar : localStorage.getItem('ar');
      if(!data['x-token']){
        let emailToken=JSON.parse(localStorage.getItem('x-token'))
        this.router.navigate([], {
          relativeTo:this.route,
          queryParams: { 'x-token':emailToken },
          queryParamsHandling: 'merge',
        });
      }
    });
    this.proposal.getData().subscribe((data: any) => {
      this.setData(data);
    });

    if ((this.route.snapshot.url[0].path !== 'plans')) {

      // console.log(this.mainService.closePayBtn, 'this.mainService.closePayBtn');

      this.mainService.closePayBtn = true;
    } else {
      this.mainService.closePayBtn = false;
    }
  }

  refreshData() {
    this.refresh_counter++;
    this.router.navigate(['/plans/' + this.contractToken], { queryParams: { refresh: this.refresh_counter } });
  }

  setData(data: any) {
    if (data.is_error) {
      this.mainService.setLoader(true);
      this.router.navigate(['/invalid']);
    } else {
      this.plans = data;
      this.planInfo = data && data.split_request_data[0];
      // console.log(this.planInfo, this.plans);
      this.planInfo.plans_array = this.planInfo.plans_array.sort((a, b) => a.month - b.month);
      this.planInfo.credit_report_status = Number((this.planInfo.hasOwnProperty('credit_report_status') ? this.planInfo.credit_report_status : 0));
      this.planInfo.credit_report_amount = Number((this.planInfo.hasOwnProperty('credit_report_amount') ? this.planInfo.credit_report_amount : 0));
      if(this.planInfo.credit_report_amount && this.planInfo.credit_report_status){
        this.creditReportOption = true;
      } else{
        this.creditReportOption = false;
      }
      // tslint:disable-next-line:max-line-length
      this.enrollmentFee = this.planInfo && this.planInfo.plans_array && this.planInfo.plans_array[0] && this.planInfo.plans_array[0].enrollment_fee ? this.planInfo.plans_array[0].enrollment_fee : 0;
      const fixed_flat_fee = this.planInfo && this.planInfo.enrollment_enabled ? 0 : this.enrollmentFee;
      this.contract_service_record = this.planInfo && this.planInfo.contract_service_record;


      if (this.planInfo.overdue_pending_contract && this.planInfo.overdue_pending_contract.length) {
        if (!this.showOverdueModal) {
          this.openPendinOverdueModal();
        }
        this.showOverdueContractBanner = true;
        this.payToken = this.planInfo.overdue_pending_contract[0].pay_recurring_token;
      } else {
        if (this.bsModalRef) {
          this.bsModalRef.hide();
        }
      }
      if (this.planInfo && this.planInfo.plans_array && this.planInfo.plans_array.length > 0) {
        this.planInfo.plans_array.forEach((item: any) => {
          if (this.planInfo.contract_type === 1) {
            if (this.planInfo.payment_reserve_on_pay) {
              item.advance_interest_amount = item.recurring_amount;
            } else {
              item.advance_interest_amount = 0;
            }
          } else if (this.planInfo.contract_type === 3) {
            if (this.planInfo.payment_reserve_on_pay_new_ten) {
              item.advance_interest_amount = item.recurring_amount;
            } else {
              item.advance_interest_amount = 0;
            }
          } else {
            item.advance_interest_amount = item.advance_interest_amount ? parseFloat(parseFloat(
              item.advance_interest_amount
            ).toFixed(2)) : 0;
          }

          // tslint:disable-next-line:max-line-length
          item.total_payable_amount = parseFloat(this.planInfo.downpayment_amount) + parseFloat(fixed_flat_fee.toString()) + this.mainService.getCalculatedTransactionFee(this.planInfo, this.planInfo.downpayment_amount) + parseFloat(item.advance_interest_amount) + this.mainService.getCalculatedTransactionFee(this.planInfo, item.advance_interest_amount);
          if (this.planInfo.credit_report_status && this.planInfo.credit_report_amount) {
            item['recurring_amount_with_credit_fee']   = item.recurring_amount + this.planInfo.credit_report_amount;
            item['to_pay_today_display'] = item?.to_pay_today +(this.planInfo?.credit_report_amount)
            item['advance_interest_amount_with_credit_fee']   = item.advance_interest_amount + this.planInfo.credit_report_amount;
            item['creditReportOption'] = true;
          }
        });
      }

      // tslint:disable-next-line:triple-equals
      if (this.planInfo && this.planInfo.contract_service_record && typeof this.planInfo.contract_service_record == 'string') {
        this.planInfo.contract_service_record = JSON.parse(this.planInfo.contract_service_record);
      }
      if (this.planInfo && this.planInfo.plans_array) {
        if (Number(this.planInfo.plans_array.length) === 1) {
          // this.selected_plan_index = 0;
          this.show_all_plans = true;
        }
      }

    }
  }

  updatePlan(plans, index) {
    // this.mainService.closeBtnHanling = true;
    this.mainService.closePayBtn = true;
    if (plans && (index !== undefined || index != null)) {
      const plan = plans[index];

      if(this.creditReportOption && this.planInfo?.country_id == 1 && !this.planInfo.plans_array[index].creditReportOption){
       this.openCreditDialog(plan, index);
      }else{
        this.selectPlan(plan, index); 
        return;
      }
    }
    // this.selected1 = true;
    else{
      this.mainService.customPopups('Please choose a payment plan.', 1);
    }
  }

  openCreditDialog(selectedPlan, index){
    this.dialog.open(CreditReportConfirmationComponent, {
          width: '500px',
          panelClass:'confirmationPopup',
          disableClose:true
        }).afterClosed().subscribe(result => {
          if(result){
            if(result?.selection){
              selectedPlan.creditReportOption = true
              this.selectPlan(selectedPlan, index);
            }
            else{
              this.selectPlan(selectedPlan, index);
            }
          }else{

          }
        });
  }








  selectPlan(plan: any, index: any) {

    if (this.planInfo.overdue_pending_contract && this.planInfo.overdue_pending_contract.length) {
      this.openPendinOverdueModal();
      return false;
    } else {
      if (this.bsModalRef) {
        this.bsModalRef.hide();
      }
    }

    const params: any = {
      contract_token: this.contractToken,
      number_of_payments: plan.month,
      recurring_amount: plan.recurring_amount,
      interest_rate: plan.interest_rate,
      interest_rate_to_show: plan.interest_rate_to_show,
      contract_type: this.planInfo.contract_type
    };
    if (this.planInfo.contract_type) {
      params.contract_type = this.planInfo.contract_type;
    }
    let tilaData;
    tilaData = {};
    tilaData.current_plan = JSON.stringify(plan);
    tilaData.credit_report_status = plan?.creditReportOption?1:0;

    localStorage.setItem('iframe_tila_data', JSON.stringify(tilaData));
    this.mainService.setLoader(true);
    this.proposal
      .api('post', 'choose_plan_v2', this.mainService.urlParams(params))
      .subscribe(
        (data: any) => {
          if (data.is_error) {
            if (data.flag === 585) {
              this.openPendinOverdueModal();
            }
            this.router.navigate(['/invalid']);
          } else {
            const creditReportParam = this.planInfo.plans_array[index].creditReportOption ? '1' : '0';
            // this.mainService.current_step = 2;
            this.router.navigateByUrl('/payment-details/' + this.contractToken + '?plan=' + index + '&cr='+creditReportParam + '&step=' + 2);
            localStorage.setItem('INDEX', JSON.stringify(index))
            setTimeout(() => {
              this.mainService.current_step = 2;
            },500);
          }
          this.mainService.setLoader(false);
        },
        (err: any) => {
          this.mainService.setLoader(false);
        }
      );
  }

  openPendinOverdueModal() {
    this.showOverdueModal = true;
    const initialState = {
      class: 'modal-md modal-445 modal-dialog-centered',
      ignoreBackdropClick: true,
      keyboard: false,
      data: {
        planInfo: this.planInfo.overdue_pending_contract,
        planToken: this.contractToken,
        refreshCounter: this.refresh_counter
      }
    };
    this.bsModalRef = this.modalService.show(PendingOverdueComponent, { initialState });
    this.bsModalRef.setClass('modal-dialog-centered');
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    if (this.showConfirmationDialog) {
      $event.returnValue = 'Are you sure you want to leave this page?';
    }
  }
  detect(eve?) {
    if (eve) {
      this.showConfirmationDialog = true;
    }
  }
  planExpendvalue() {
    this.planExpanded = !this.planExpanded;
  }
  goBack() {
    this.router.navigateByUrl('credee-bill/' + this.contractToken);
  }

  mapRecurringAmout(value: boolean) {
        const feeInCents = this.planInfo.credit_report_amount * 100;
        this.planInfo.plans_array.forEach((plan: any, index:number) => {
        if (this.originalRecurringAmounts[index] === undefined) {
          this.originalRecurringAmounts[index] = plan.recurring_amount;
        }
        if (this.originalToPayTodayAmounts[index] === undefined) {
          this.originalToPayTodayAmounts[index] = plan.to_pay_today;
        }
        const originalRecurringAmountInCents = Math.round(this.originalRecurringAmounts[index]* 100);
        const newRecurringAmountInCents = value ? originalRecurringAmountInCents + feeInCents : originalRecurringAmountInCents;
        const currentRecurringAmountInCents = Math.round(plan.recurring_amount_with_credit_fee * 100);

        const originalToPayTodayInCents = Math.round(this.originalToPayTodayAmounts[index] * 100);
        const newToPayTodayInCents = value ? originalToPayTodayInCents + feeInCents : originalToPayTodayInCents;
        const currentToPayTodayInCents = Math.round(plan.to_pay_today_display * 100);
        this.animateCounter(currentRecurringAmountInCents, newRecurringAmountInCents, plan, 'recurring_amount_with_credit_fee', 500);

        this.animateCounter(currentToPayTodayInCents, newToPayTodayInCents, plan, 'to_pay_today_display',500);
        plan.creditReportOption = value;
        // this.api_credit_report_status = value;
    });
  }

  private animateCounter(startValue: number, endValue: number, plan: any, prop: string, duration: number = 500) {
    const startTime = performance.now();

    const updateCount = (timestamp: number) => {
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const currentValue = startValue + (endValue - startValue) * progress;
      plan[prop] = (currentValue / 100).toFixed(2);
      if (progress < 1) {
        requestAnimationFrame(updateCount);
      } else {
        plan[prop] = (endValue / 100).toFixed(2);
      }
    };

    requestAnimationFrame(updateCount);
  }

    toggleCreditOption() {
    const newValue = !this.planInfo.plans_array.every(plan => plan.creditReportOption);
    this.mapRecurringAmout(newValue);
  }
  public getTopay(amt, creditReportOption) {
    let newAmt = amt;
    if (!creditReportOption || !this.planInfo.payment_reserve_on_pay_new_ten) {
      return newAmt;
    } else {
      newAmt = newAmt + +this.planInfo.credit_report_amount
      return newAmt;
    }

  }




}
